import React, { Component } from "react";
import { DefaultInput } from "@alboompro/boom-components/data-entry/input/";
import styled from "styled-components";
import EditorLabel from "editor/components/EditorLabel";
import { PropListItem } from "./styles";

const CustomPropListItem = styled(PropListItem)`
  position: relative;
  user-select: none;
  > div {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  label {
    user-select: none;
  }
`;

const CustomDefaultInput = styled(DefaultInput)`
  input {
    border: 1px solid #ebebeb;
    border-radius: 3px;
    &:focus {
      box-shadow: rgb(80 175 244) 0px 0px 2px 1px;
    }
    ::placeholder {
      font-size: 11px;
    }
  }
`;

const Icon = styled.img`
  position: absolute;
  z-index: 1;
  left: 12px;
  height: 14px;
  width: 14px;
  bottom: 18.5px;
`;

class Input extends Component {
  state = {
    value: "",
    placeholder: "",
  };

  componentDidMount() {
    const { currentValue, placeholder, locale } = this.props;
    this.setState({
      value: currentValue,
      placeholder: !placeholder ? "" : placeholder[locale],
    });
  }

  handleUpdate = (e) => {
    const { updaterFn, name } = this.props;
    this.setState({ value: e.target.value });
    if (updaterFn && typeof updaterFn === "function") {
      updaterFn({ prop: name, value: e.target.value });
    }
  };

  onKeyPress = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      this.handleUpdate(e);
    }
  };

  render() {
    const { label, name, locale, tooltip, icon, disabled } = this.props;
    const { value, placeholder } = this.state;
    const tooltipText = (tooltip && tooltip[locale]) || null;

    return (
      <CustomPropListItem>
        {icon && <Icon alt="icon" src={icon} />}
        <CustomDefaultInput
          name={name}
          label={
            <EditorLabel tooltip={tooltipText}>{label[locale]}</EditorLabel>
          }
          inputStyle={{ fontSize: "12px", padding: icon ? "8px 10px 8px 32px" : "8px 10px" }}
          labelStyle={{
            fontSize: "12px",
            lineHeight: "normal",
            marginBottom: "3px",
          }}
          placeholder={placeholder}
          value={value}
          onChange={this.handleUpdate}
          onKeyPress={this.onKeyPress}
          disabled={disabled || false}
        />
      </CustomPropListItem>
    );
  }
}

export default Input;
